export default {"src":"/org/_next/static/media/recurring.2d9d210a.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};